/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Planning_NoteInputs */

const en_mk_team_planning_note = /** @type {(inputs: Mk_Team_Planning_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planning, chat, and review use a separately selected AI source: Bystep AI or your API connection. A coding agent subscription does not automatically provide API access for those stages.`)
};

const id_mk_team_planning_note = /** @type {(inputs: Mk_Team_Planning_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI untuk rencana, chat, dan review dipilih terpisah: AI Bystep atau koneksi API-mu. Login langganan agent untuk coding tidak otomatis menyediakan akses API untuk tahap tersebut.`)
};

/**
* | output |
* | --- |
* | "Planning, chat, and review use a separately selected AI source: Bystep AI or your API connection. A coding agent subscription does not automatically provide ..." |
*
* @param {Mk_Team_Planning_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_planning_note = /** @type {((inputs?: Mk_Team_Planning_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Planning_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_planning_note(inputs)
	return en_mk_team_planning_note(inputs)
});